export const PaymentCardsActionTypes = {
  GET_PAYMENT_CARDS: 'GET_PAYMENT_CARDS',
  DELETE_PAYMENT_CARDS_LIST: 'DELETE_PAYMENT_CARDS_LIST',
  UPDATE_PAYMENT_CARD: 'UPDATE_PAYMENT_CARD',
  UPDATE_PAYMENT_CARD_LIST: 'UPDATE_PAYMENT_CARD_LIST',
};
